import React, { HTMLAttributes } from "react";

import { Icon } from "components";

import { COVER_CROP_CHIP, CoverCropChip, formatConfidence } from "pages/admin/verifications/utils/coverCropChips";

const STRIP_CLASS: Record<COVER_CROP_CHIP, string> = {
  [COVER_CROP_CHIP.CONFIRMED]: "confirmed",
  [COVER_CROP_CHIP.NOT_DETECTED]: "not-detected",
  [COVER_CROP_CHIP.MISSING]: "missing",
};

const STRIP_TEXT: Record<COVER_CROP_CHIP, (confidence: string) => string> = {
  [COVER_CROP_CHIP.CONFIRMED]: (confidence) => confidence,
  [COVER_CROP_CHIP.NOT_DETECTED]: (confidence) => `${confidence} · not detected`,
  [COVER_CROP_CHIP.MISSING]: (confidence) => `${confidence} · missing cover crop`,
};

// The satellite strip at the top of a crop tile: green when the satellite agrees with the farmer's cover
// crop, red when it saw none.
export const CoverCropStrip = ({ chip }: { chip: CoverCropChip }) => (
  <div className={`tile-strip ${STRIP_CLASS[chip.type]}`} data-testid="cover-crop-strip">
    <Icon iconName="tabler/satellite" size="s" className="icon" />
    {STRIP_TEXT[chip.type](formatConfidence(chip.confidence))}
  </div>
);

// Its own dashed tile in the year column: the satellite saw a cover crop the farmer didn't add.
export const MissingCoverCropTile = ({ chip, triggerProps }: { chip: CoverCropChip; triggerProps: HTMLAttributes<HTMLDivElement> }) => (
  <div className="practice-item cover-crop-missing has-evidence" data-testid="cover-crop-missing" {...triggerProps}>
    <CoverCropStrip chip={chip} />
  </div>
);
